// Production-ready logging utility
// Automatically disables debug logging in production builds
// Keeps error logging always active for debugging

const isDevelopment = import.meta.env.DEV;

export const logger = {
  // Always log errors, even in production
  error: (...args: any[]) => {
    console.error(...args);
  },
  
  // Only log warnings in development or when debug flag is set
  warn: (...args: any[]) => {
    if (isDevelopment) {
      console.warn(...args);
    }
  },
  
  // Only log info/debug in development
  log: (...args: any[]) => {
    if (isDevelopment) {
      console.log(...args);
    }
  },
  
  // High-frequency debug logs (like render cycles) - heavily throttled even in dev
  debug: (...args: any[]) => {
    if (isDevelopment && Math.random() < 0.1) { // Only 10% of debug logs
      console.log('[DEBUG]', ...args);
    }
  },
  
  // Performance-critical logs - only when explicitly enabled
  trace: (...args: any[]) => {
    if (isDevelopment && localStorage.getItem('enable_trace_logs') === 'true') {
      console.log('[TRACE]', ...args);
    }
  }
};

// For immediate production performance, disable console noise
if (!isDevelopment) {
  // Override console methods in production builds
  console.log = () => {};
  console.debug = () => {};
  console.info = () => {};
  // Keep console.warn and console.error for critical issues
}
